import React, { Component } from 'react';
import { image } from '../Hr/graydot.png';
import HrMiddleWare from '../../middleWare/HrMiddleWare';

class BehaviouralCompetencies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: this.props.id,
      data: this.props.data,
      userDetails: this.props.userDetails,
      head: []
    };
  }
  async componentWillMount() {
    let data = this.state.data;
    let userDetails = this.state.userDetails;
    console.log(userDetails.customerid);
    const adminId = userDetails.customerid;
    let Level;
    // = await HrMiddleWare.getRandomData(
    //   "tbl_competency,mapped_matrix_to_user,tbl_cmpLevel",
    //   `tbl_competency.id = mapped_matrix_to_user.competencyId and tbl_competency.customerid = ${adminId} and tbl_competency.adminId = ${adminId}  and mapped_matrix_to_user.levelid = tbl_cmpLevel.id and mapped_matrix_to_user.adminId = ${adminId} and tbl_cmpLevel.matrixType = 'Behavioral' and tbl_cmpLevel.CustomerID = ${adminId} and tbl_cmpLevel.adminId = ${adminId}`,
    //   "tbl_cmpLevel.Level as level , mapped_matrix_to_user.competencyId as compId"
    // );
    // console.log(Level);
    // console.log("test");
    let head = [];

    if (data.userBehIndicators) {
      data.userBehIndicators.map((item, index) => {
        let level = [];
        let cmplevalue = [];
        item.indicators.map((element, key) => {
          console.log(element);
          level.push(
            <li style={{ marginTop: '5px', color:"var(--text-color)" }}>
              {/* <img style={{ width: '10px', marginRight: '5px' }} src={image} /> */}
              {element.indicators} &nbsp;
            </li>
          );
          cmplevalue.push(<p>{element.cmplevel}</p>);
        });
        head.push(
          <div>
            <dt class="text-primary">
              Competency {index + 1}&nbsp;&nbsp;&gt;&gt;&nbsp;&nbsp;
              {item.competencyname}
            </dt>
            <dl>
              <dt class="text-success" id="cardSupplies">
                {/* Level-1 */}
                {cmplevalue}
              </dt>
              <ul>
                {level}
                {/* Rarely shows enthusiasm and passion for achieving results
                            </li>	 */}
              </ul>
            </dl>
          </div>
        );
      });
    }
    this.setState({ head });
  }

  render() {
    const { data, head } = this.state;
    return (
      <div>
        <section class="panel">
          <div class="panel-body bio-graph-info">
            <div class="row">
              <div class="col-lg-12 text">
                <div class="hpanel hgreen">
                  <div class="panel-heading">
                    <div class="panel-tools">{head}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default BehaviouralCompetencies;
